
import axios from 'axios'
import { token } from './auth-header'

// const API_URL = 'http://localhost:8080/api/auth/';

class DataService {
  async getServices () {
    return await axios
      .get('service-cat-list', {
        headers: {
          Authorization: `Token ${token()}`
        }
      })
      .then(response => {
        console.log(response)
        return response.data
      })
  }

  async getTasks () {
    return await axios
      .get('tasks', {
        headers: {
          Authorization: `Token ${token()}`
        }
      })
      .then(response => {
        console.log(response)
        return response.data
      })
  }

  async getTask (id) {
    return await axios
      .get(`tasks/${id}/`, {
        headers: {
          Authorization: `Token ${token()}`
        }
      })
      .then(response => {
        console.log(response)
        return response.data
      })
  }

  async searchProfile (id) {
    return await axios
      .get('profile-search/' + id, {
        headers: {
          Authorization: `Token ${token()}`
        }
      })
      .then(response => {
        console.log(response)
        return response.data
      })
  }

  async sendMessage (data) {
    const formData = new FormData()
    formData.append('message', data.message)
    formData.append('selectUser', data.selectedUser)
    formData.append('user', data.user)
    return await axios
      .post('send-message', formData, {
        headers: {
          Authorization: `Token ${token()}`
        }
      })
      .then(response => {
        console.log(response)
        return response.data
      })
  }

  async submitRating (data) {
    const formData = new FormData()
    formData.append('score', data.score)
    formData.append('message', data.message)
    formData.append('task', data.task)
    return await axios
      .post('send-review', formData, {
        headers: {
          Authorization: `Token ${token()}`
        }
      })
      .then(response => {
        console.log(response)
        return response.data
      })
  }

  async deleteProfile (data) {
    return await axios
      .delete('profile/delete', {
        headers: {
          Authorization: `Token ${token()}`,
          'Content-Type': 'application/json'
        },
        data: {
          confirm_deletion: data.confirm_deletion,
          reason: data.reason
        }
      })
      .then(response => {
        console.log(response)
        return response.data
      })
  }

  // Public API methods (no authentication required)
  async getPublicServices () {
    return await axios
      .get('public/service-cat-list')
      .then(response => {
        console.log(response)
        return response.data
      })
  }

  async searchPublicProfile (id) {
    return await axios
      .get('public/profile-search/' + id)
      .then(response => {
        console.log(response)
        return response.data
      })
  }

  async getPublicServiceList () {
    return await axios
      .get('public/service-list/')
      .then(response => {
        console.log(response)
        return response.data
      })
  }
}

export default new DataService()
